import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/images/loadapi-hero-logistics.jpg"
          alt="Trucking logistics hub"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at top, rgba(59,130,246,0.08), transparent 55%)',
        }}
      />

      <div className="relative z-10 w-full px-6 md:px-10 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            One API. Every Load Board.
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
            LoadAPI.io aggregates real-time freight listings from the industry&apos;s top brokers.
            Filter, search, and connect — all through a single, powerful API.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/features"
              className="px-8 py-3.5 bg-white text-zinc-900 text-sm font-semibold rounded-full hover:bg-zinc-100 transition-colors whitespace-nowrap"
            >
              Explore Features
            </Link>
            <Link
              to="/join"
              className="px-8 py-3.5 bg-blue-600 text-white text-sm font-semibold rounded-full hover:bg-blue-700 transition-colors whitespace-nowrap"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
